import SubPage from './SubPage';
import type SubPageProps from './SubPageProps';

export * from './PageActions';
export default SubPage;
export type { SubPageProps };
